import { useEffect, useState } from "react";
import "./BackgroundPaths.css";
// import Button from "./Button";

const FloatingPaths = ({ position }) => {
  const [paths, setPaths] = useState([]);

  useEffect(() => {
    const generatedPaths = Array.from({ length: 36 }, (_, i) => {
      const d = `M-${380 - i * 5 * position} -${189 + i * 6}C-${
        380 - i * 5 * position
      } -${189 + i * 6} -${312 - i * 5 * position} ${216 - i * 6} ${
        152 - i * 5 * position
      } ${343 - i * 6}C${616 - i * 5 * position} ${470 - i * 6} ${
        684 - i * 5 * position
      } ${875 - i * 6} ${684 - i * 5 * position} ${875 - i * 6}`;

      const color = `rgba(15,23,42,${0.1 + i * 0.03})`;
      const width = 0.5 + i * 0.03;

      return { id: i, d, color, width };
    });

    setPaths(generatedPaths);
  }, [position]);

  return (
    <svg className="floating-svg" viewBox="0 0 696 316" fill="none">
      <title>Background Paths</title>
      {paths.map((path) => (
        <path
          key={path.id}
          d={path.d}
          stroke={path.color}
          strokeWidth={path.width}
          className="animated-path"
        />
      ))}
    </svg>
  );
};

const BackgroundPaths = ({ isBackground = true }) => {
  return (
    <div
      className="background-container"
      style={{ background: isBackground ? "#ffffff" : "transparent" }}
    >
      <div className="floating-container">
        <FloatingPaths position={1} />
        <FloatingPaths position={-1} />
      </div>
    </div>
  );
};

export default BackgroundPaths;
